import React from 'react';
import PropTypes from 'prop-types';
import { PAPER_TABS } from '../../data/common';

function VocaTestPaperSetBtns({ tab, setTab }) {
  return (
    <div className="relative w-[362px] h-[48px] min-h-[48px] flex justify-around items-center gap-[10px] bg-[#fff] py-[6px] px-[16px] rounded-[60px] mb-[15px]">
      <button
        type="button"
        className="z-10 text-[#1E293B] text-[12px] font-[400]"
        onClick={() => setTab(PAPER_TABS.TEST_PAPER)}
        style={{
          color: tab === PAPER_TABS.TEST_PAPER ? '#773DBD' : '#1E293B',
          fontWeight: tab === PAPER_TABS.TEST_PAPER ? 700 : 400,
        }}
      >
        시험지
      </button>
      <button
        type="button"
        className="z-10 text-[#1E293B] text-[12px] font-[400]"
        onClick={() => setTab(PAPER_TABS.ANSWER)}
        style={{
          color: tab === PAPER_TABS.ANSWER ? '#773DBD' : '#1E293B',
          fontWeight: tab === PAPER_TABS.ANSWER ? 700 : 400,
        }}
      >
        정답만
      </button>
      <button
        type="button"
        className="z-10 text-[#1E293B] text-[12px] font-[400]"
        onClick={() => setTab(PAPER_TABS.ANSWER_TEST_PAPER)}
        style={{
          color: tab === PAPER_TABS.ANSWER_TEST_PAPER ? '#773DBD' : '#1E293B',
          fontWeight: tab === PAPER_TABS.ANSWER_TEST_PAPER ? 700 : 400,
        }}
      >
        정답이 표시된 시험지
      </button>
      <button
        type="button"
        className="z-10 text-[#1E293B] text-[12px] font-[400]"
        onClick={() => setTab(PAPER_TABS.VOCABULARY_LIST)}
        style={{
          color: tab === PAPER_TABS.VOCABULARY_LIST ? '#773DBD' : '#1E293B',
          fontWeight: tab === PAPER_TABS.VOCABULARY_LIST ? 700 : 400,
        }}
      >
        어휘 리스트
      </button>
      <div
        className="absolute top-[50%] bg-[#DFC5FF] rounded-[60px] h-[36px] z-5"
        style={{
          transform: 'translatey(-50%)',
          transition: '0.2s ease-in-out',
          width: `${tab === PAPER_TABS.TEST_PAPER ? 60 : tab === PAPER_TABS.ANSWER_TEST_PAPER ? 130 : tab === PAPER_TABS.ANSWER ? 60 : 80}px`,
          left: `${tab === PAPER_TABS.TEST_PAPER ? 12 : tab === PAPER_TABS.ANSWER_TEST_PAPER ? 135 : tab === PAPER_TABS.ANSWER ? 74 : 268}px`,
        }}
      />
    </div>
  );
}

VocaTestPaperSetBtns.propTypes = {
  tab: PropTypes.string.isRequired,
  setTab: PropTypes.func.isRequired,
};

export default React.memo(VocaTestPaperSetBtns);
